module.exports = __webpack_public_path__ + "static/media/3.eb0d110e.png";